import React from 'react'
import BreadCrumb from '../../components/BreadCrumb';
import { BaseUrl } from '../../helper/BaseUrl';

export default function DynamicBanner({ data, breadcrumb, extraClass = "" }) {
  if (!data) return null;
  return (
    <>
      <section className={`industries-banner ${extraClass}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
              <div className="about-bio-box">
                <div >
                  {breadcrumb && <BreadCrumb data={breadcrumb} />}
                  <h1 className="heading">{data?.section1_title}</h1>
                  <p> {data?.section1_description}  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-6"></div>
          </div>
        </div>
        <img src={data?.section1_image ? `${BaseUrl}${data.section1_image}` : undefined} className="banner-right-img" alt={data?.alt_banner_image} />
      </section>
    </>
  )
}

